import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const confirmToInviteReducer = createReducer<State, Actions>(initialState, {
  [actions.sendConfirmToInvite.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.sendConfirmToInvite.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.sendConfirmToInvite.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.sendConfirmToInvite.reset.type]: actionsHandlers.handleSingleFeatureReset,
});

export default confirmToInviteReducer;
